import React, { useState } from 'react'
import { Box as MuiBox, Typography } from '@mui/material'
import LinearProgress, {
  linearProgressClasses
} from '@mui/material/LinearProgress'
import PropTypes from 'prop-types'

export default function BorderLinearProgress(props) {
  // const { color, quantity, unit, value } = props (Add needed props)
  const { current, total } = props
  const [viewProfile, switchViewProfile] = useState(true)

  const toggleProgressIndicator = () => {
    switchViewProfile(!viewProfile)
  }

  return (
    <MuiBox
      sx={{
        flexGrow: 1,
        position: 'relative'
      }}
      onMouseEnter={toggleProgressIndicator}
      onMouseLeave={toggleProgressIndicator}
    >
      <LinearProgress
        variant='determinate'
        value={(current / total) * 100}
        sx={{
          height: '2em',
          borderRadius: 4,
          radius: '1px',
          border: '1px solid #B8C4D3',
          [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: '#E8E9FD'
          },
          [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 4,
            borderTopRightRadius: 1,
            borderBottomRightRadius: 1,
            backgroundColor: '#A4AAFF'
          },
          zIndex: 1
        }}
      />
      {/* Change negative margin to more flexible style */}
      <MuiBox
        style={{ position: 'absolute', top: '-6px', left: '15px', zIndex: 2 }}
      >
        {viewProfile ? (
          <Typography variant='subtitle1'>
            {current} / <strong>{total}</strong>
          </Typography>
        ) : (
          <Typography variant='subtitle1'>
            <strong>{((current / total) * 100).toFixed(1)}%</strong>
          </Typography>
        )}
      </MuiBox>
    </MuiBox>
  )
}

BorderLinearProgress.propTypes = {
  /* (Fill needed props)
    color: PropTypes.string,
    quantity: PropTypes.number.isRequired,
    unit: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  */
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}
